module.exports = __webpack_public_path__ + "static/media/6_INSERT-HPV-VIDEO-SECTION.47cc967d.png";